import axios from "axios";
// let locationorigin = window.location.origin
// let regexpatt = /\W?\d*$/
// let windowobj = locationorigin.replace(regexpatt, "");

const apiClient = axios.create({
  baseURL:
    process.env.NODE_ENV == "development"
      ? `${process.env.VUE_APP_LOCAL_API_ORIGIN}`
      : `${process.env.VUE_APP_LIVE_API_ORIGIN}`,
  headers: { Pragma: "no-cache", "Cache-Control": "no-store" }
});

// const apiClientV2 = axios.create({
//   baseURL:
//     process.env.NODE_ENV == "development"
//       ? `${process.env.VUE_APP_LOCAL_API_V2_ORIGIN}`
//       : `${process.env.VUE_APP_LIVE_API_V2_ORIGIN}`,
//   headers: {
//     Pragma: "no-cache",
//     "Cache-Control": "no-store"
//   }
// });

export default {
  sendSelect(selectObj) {
    return apiClient.post("/exam.class.php", {
      action: "Pre-Start",
      selectObj
    });
  },
  updateConfig(newconfig, answered, modeconfig) {
    return apiClient.post("/exam.class.php", {
      action: "Update Config",
      newconfig,
      answered,
      modeconfig
    });
  },
  getInstitutions() {
    return apiClient.post("/exam.class.php", {
        action : "get-all-institutions"
    });
  },
  getCategories() {
    return apiClient.post("/exam.class.php", {
        action : "get-all-categories"
    })
  },
  updateModeconfig(modeconfig, config_dir) {
    return apiClient.post("/exam.class.php", {
      action: "update-mode-config",
      modeconfig,
      config_dir
    });
  },
  getTopics() {
    return apiClient.post("/exam.class.php", {
        action : 'get-all-topics'
    });
  },
  getRefdiscount(useremail){
      return apiClient.post("/exam.class.php", {
            action : 'get-user-refdiscount',
            useremail
      });
  },
  applyCouponDisc(payload){
    return apiClient.post("/user.class.php", {
          action : 'apply-coupon',
          payload
    });
  },
  getAllInstitutions(query) {
    return apiClient.post(`/exam.class.php${query}`, {
        action : "get-institutions-all"
    });
  },
  getAllInstitutionsTabled(query) {
    return apiClient.post(`/exam.class.php${query}`, {
        action : "get-institutions-tabled"
    });
  },
  getAllCategories(query) {
    return apiClient.post(`/exam.class.php${query}`, {
        action : "get-categories-all"
    })
  },
  getAllCategoriesTabled(query) {
    return apiClient.post(`/exam.class.php${query}`, {
        action : "get-categories-tabled"
    })
  },
  
};
